'use client'
// =============================================================================
// InfraStatus — widget TOOLS (right-panel) : "Runtime Health — ce sont des
// services." Source stricte : /health (infra-health.ts côté API), le MÊME
// endpoint déjà utilisé par FooterRealtime — jamais un 2e check de santé.
// =============================================================================
import { useEffect, useState } from 'react'

interface ServiceState { status?: string; latencyMs?: number; detail?: string }
interface HealthData { status: 'ok' | 'degraded'; services: Record<string, ServiceState> }

const LABELS: Record<string, string> = {
  db: 'PostgreSQL', cache: 'Redis', qdrant: 'Qdrant', ollama: 'Ollama', searxng: 'SearXNG', minio: 'MinIO',
}

export function InfraStatus() {
  const [health, setHealth] = useState<HealthData | null>(null)

  useEffect(() => {
    const apiUrl = process.env.NEXT_PUBLIC_API_URL ?? ''
    const check = () =>
      fetch(`${apiUrl}/health`).then(r => r.json()).then(setHealth).catch(() => null)
    check()
    const iv = setInterval(check, 30_000)
    return () => clearInterval(iv)
  }, [])

  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 9, letterSpacing: '0.12em', color: 'rgba(255,255,255,0.2)', marginBottom: 6, fontFamily: 'var(--font-mono)' }}>
        INFRA STATUS
      </div>
      {!health ? (
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.15)', fontFamily: 'var(--font-mono)' }}>⟳ Chargement…</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {Object.entries(health.services).map(([key, s]) => {
            const ok = s.status === 'ok'
            const color = ok ? '#34d399' : s.status === 'busy' ? '#f5a623' : '#ef4444'
            return (
              <div key={key} style={{
                display: 'flex', alignItems: 'center', gap: 8, padding: '4px 8px',
                borderRadius: 6, background: `${color}0a`, fontFamily: 'var(--font-mono)', fontSize: 10.5,
              }}>
                <span style={{ width: 5, height: 5, borderRadius: '50%', background: color, flexShrink: 0 }} />
                <span style={{ flex: 1, color: 'rgba(255,255,255,0.6)' }}>{LABELS[key] ?? key}</span>
                {typeof s.latencyMs === 'number' && (
                  <span style={{ fontSize: 8, color: 'rgba(255,255,255,0.2)' }}>{s.latencyMs}ms</span>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
